import { createRoutine } from "../utils/routine.utils";
export var getPricing = createRoutine("PRICING_GET");
export var createPricing = createRoutine("PRICING_CREATE");
export var updatePricing = createRoutine("PRICING_UPDATE");
export var deletePricing = createRoutine("PRICING_DELETE");
export var getPricingsPaged = createRoutine("PRICING_GET_PAGED");
